import { useNavigate } from 'react-router-dom';
import Card from '../../components/card/card';
import styles from './providerStep.module.css';
import RegisteredProvider from '../../../img/icons/registered-provider.svg';
import ProspectiveProvider from '../../../img/icons/prospective-provider.svg';
import OtherProvider from '../../../img/icons/other-provider.svg';

export default function ProviderStep ({ formData, setFormData, defaultState }) {
  const navigate = useNavigate();

  const handleChange = ({ target: { value } }) => {
    setFormData((prev) => ({
      ...prev,

      providerStep: {
        provider: value,
        isValid: true
      },

      descriptionStep:
      value === 'other'
        ? prev.descriptionStep
        : defaultState.descriptionStep,

      locationStep:
      (value === 'registered' || value === 'prospective') &&
      prev.descriptionStep?.value === 'dpo'
        ? defaultState.locationStep
        : prev.locationStep,

      servicesStep:
      (value === 'registered' || value === 'prospective') &&
      prev.descriptionStep?.value === 'dpo'
        ? defaultState.servicesStep
        : prev.servicesStep,
      fundingStep:
      (value === 'registered' || value === 'prospective') &&
      prev.descriptionStep?.value === 'dpo'
        ? defaultState.fundingStep
        : prev.fundingStep,
      govEntityStep:
      (value === 'registered' || value === 'prospective') &&
      prev.descriptionStep?.value === 'dpo'
        ? defaultState.govEntityStep
        : prev.govEntityStep

    }));
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('p', value);
    navigate(`?${searchParams}`, { replace: true });
  };

  const providerOptions = [
    {
      label: 'Registered provider',
      description: 'I am a registered provider delivering aged care services.',
      icon: <RegisteredProvider aria-hidden />,
      value: 'registered'
    },
    {
      label: 'Prospective provider',
      description: 'I am interested in becoming a registered aged care provider and want to know the requirements.',
      icon: <ProspectiveProvider aria-hidden />,
      value: 'prospective'
    },
    {
      label: 'I work with or for a registered provider',
      icon: <OtherProvider aria-hidden />,
      description: 'I am an associated provider, an aged care worker, a responsible person, a digital platform operator, or I would like to learn more about aged care provider requirements.',
      value: 'other'
    }
  ];

  return (
    <div className={`${styles.pageContainer}`}>
      <legend id='heading--describes-you'>
        <h2 className={styles.mobileH2}>
          Which of the following best describes you?
        </h2>
      </legend>
      <p style={{ color: '#5B6770', textAlign: 'center', marginTop: '12px' }}>
        This helps us match the requirements with the services you deliver or
        are interested in.
      </p>
      <p style={{ marginTop: '12px', marginBottom: '24px' }}>
        Please select one option and click 'Next'.
      </p>
      <fieldset className={styles.multiCardContainer} aria-labelledby='heading--describes-you'>
        {providerOptions.map(option => (
          <Card
            description={option.description}
            icon={option.icon}
            key={option.value}
            label={option.label}
            name='provider'
            value={option.value}
            checked={formData.providerStep.provider === option.value}
            onChange={handleChange}
          />
        ))}
      </fieldset>
    </div>
  );
}
